import type { LocaleDictionary } from "@/i18n/types";

const nsDialogEN = {
  common: {
    backButton: "Back",
    cancelButton: "Cancel",
    completeButton: "Done",
  },
  inProgress: {
    defaultTitle: "Processing",
    defaultSubText: "Please wait until this completes...",
  },
  error: {
    codeLabel: "Error code",
    messageLabel: "Error message",
  },
  offline: {
    title: "Network error",
    message: "You are offline. Check your network connection.",
  },
  operationStatus: {
    waiting: "Pending",
    inProgress: "Running",
    success: "Success",
    failed: "Failed",
  },
  bulk: {
    targetCount: ({ count }: { count: number }) => `Targets: ${count}`,
    resultSummary: ({ success, failed }: { success: number; failed: number }) =>
      `Succeeded: ${success} / Failed: ${failed}`,
    abortedSuffix: "(stopped partway)",
    stopOnFailureLabel: "Stop the rest on failure",
    stoppingButton: "Stopping...",
    stopButton: "Stop",
    // operationName は呼び出し側から日本語で渡るので en では文面に含めない
    noTargetSelected: (_params: { operationName: string }) =>
      "No items are selected.",
    stoppedNotification: (_params: { operationName: string }) =>
      "Stopped partway through.",
    partialFailureNotification: (_params: { operationName: string }) =>
      "Some items failed.",
    completedNotification: (_params: { operationName: string }) => "Completed.",
  },
  memberSelection: {
    requiredMessage: "Select the members to act on.",
  },
} satisfies LocaleDictionary;

export default nsDialogEN;
